module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ThePageExternal', {
    attrs: {
      "title": 'SIGNUP__NEW_ACCOUNT',
      "class-name": 'SignUpView'
    }
  }, [(_vm.isEmailConfirmationPending) ? [_c('div', {
    staticClass: "SignUpView__account-created"
  }, [_vm._v("\n            " + _vm._s(_vm.translate('SIGNUP__ACCOUNT_CREATED')) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "SignUpView__email-activity"
  }, [_c('div', {
    staticClass: "SignUpView__email-activity_content"
  }), _vm._v(" "), _c('div', {
    staticClass: "SignUpView__email-activity-icon-container"
  }, [_c('i', {
    staticClass: "icon-mail SignUpView__email-activity-icon"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "SignUpView__waiting-confirmation"
  }, [_vm._v("\n            " + _vm._s(_vm.translate('SIGNUP__WAITING_FOR_EMAIL_CONFIRMAITON')) + " "), _c('span', {
    staticClass: "SignUpView__waiting-confirmation-email"
  }, [_vm._v(_vm._s(_vm.email))]), _vm._v("...\n        ")])] : [_c('div', {
    staticClass: "SignUpView__content"
  }, [_c('div', {
    staticClass: "SignUpView__column"
  }, [_c('BaseText', {
    attrs: {
      "label": 'SIGNUP__EMAIL',
      "value": _vm.email,
      "errors": _vm.errors['email'],
      "autofocus": true,
      "icon": 'icon-mail'
    },
    on: {
      "change": function($event) {
        _vm.setEmail($event.target.value)
      }
    }
  }), _vm._v(" "), _c('BaseText', {
    attrs: {
      "label": 'SIGNUP__PASSWORD',
      "value": _vm.password,
      "errors": _vm.errors['password'],
      "icon": 'icon-lock',
      "password": true
    },
    on: {
      "change": function($event) {
        _vm.setPassword($event.target.value)
      }
    }
  }), _vm._v(" "), _c('BaseText', {
    attrs: {
      "label": 'SIGNUP__CONFIRM_PASSWORD',
      "value": _vm.confirmPassword,
      "errors": _vm.errors['confirmPassword'],
      "icon": 'icon-cw-1',
      "password": true
    },
    on: {
      "change": function($event) {
        _vm.setConfirmPassword($event.target.value)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "SignUpView__column"
  }, [_c('BaseText', {
    attrs: {
      "label": 'SIGNUP__NAME',
      "value": _vm.name,
      "errors": _vm.errors['name'],
      "icon": 'icon-child'
    },
    on: {
      "change": function($event) {
        _vm.setName($event.target.value)
      }
    }
  }), _vm._v(" "), _c('BaseText', {
    attrs: {
      "label": 'SIGNUP__COMPANY_NAME',
      "value": _vm.company,
      "errors": _vm.errors['company'],
      "icon": 'icon-bank'
    },
    on: {
      "change": function($event) {
        _vm.setCompany($event.target.value)
      }
    }
  }), _vm._v(" "), _c('BaseDropdown', {
    attrs: {
      "label": 'SIGNUP__TIMEZONE',
      "value": _vm.timezone,
      "items": _vm.timezones,
      "errors": _vm.errors['timezone'],
      "icon": 'icon-clock'
    },
    on: {
      "change": function($event) {
        _vm.setTimezone($event.target.value)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "SignUpView__terms"
  }, [_c('BaseCheckbox', {
    attrs: {
      "label": 'SIGNUP__I_AGREE_TO',
      "value": _vm.termsAccepted,
      "field-name": 'termsAccepted',
      "errors": _vm.errors['termsAccepted'],
      "link": _vm.termsLink,
      "link-label": 'SIGNUP__TO_TERMS_AND_CONDITIONS'
    },
    on: {
      "change": function($event) {
        _vm.setTermsAccepted($event.target.checked)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "SignUpView__actions"
  }, [_c('BaseButtonFlat', {
    attrs: {
      "label": 'SIGNUP__TO_SIGN_IN',
      "class-name": 'SignUpView__signin'
    },
    on: {
      "click": function($event) {
        _vm.openSignIn()
      }
    }
  }), _vm._v(" "), _c('BaseButton', {
    attrs: {
      "label": 'SIGNUP__SIGN_UP'
    },
    on: {
      "click": function($event) {
        _vm.signup($event.target)
      }
    }
  })], 1)]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-524b1636"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/SignUpView.vue
// module id = 509
// module chunks = 1